import React, {FC, useEffect, useState} from 'react';
import { Link, useNavigate } from "react-router-dom";
import styles from './Header.module.css';
import '../../Shared.css';
import logo from '../../resources/common/Header_Logo.png';

import { useAuth } from "../../services/AuthProvider";
import NavigateButton from "../NavLink/NavigateButton";

const ResourcesMenu: React.FC = () => (
  <div className={styles.ResourcesMenu}>
    <a href="https://landing.sparx.org.nz/friends-and-whanau">Friends &amp; Whānau</a>
    <a href="https://landing.sparx.org.nz/teachers-and-healthprofessionals">Teachers &amp; Health Professionals</a>
    <a href="https://landing.sparx.org.nz/publications">Publications</a>
    <a href="https://www.sparx.org.nz/support">FAQs</a>
  </div>
);

const NavBar: FC = () => {
  const { isLoggedIn, userProfile, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn && !userProfile) {
      logout();
    }
  }, [isLoggedIn, userProfile, logout]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleResourcesClick = () => {
    window.location.href = "https://landing.sparx.org.nz/";
  };

  return (
    <div className={styles.HeaderNavBar}>
      <div style={{ margin: '0', whiteSpace: 'nowrap' }}>
        <Link to="https://www.sparx.org.nz/the-game" className={styles.HeaderMenuNavLink}>The Game</Link>
        <Link to="https://landing.sparx.org.nz/about-us" className={styles.HeaderMenuNavLink}>About Us</Link>
        <span className={styles.HeaderMenuNavLink} onClick={handleResourcesClick}>
          <span className={styles.ResourcesHoverMenu}>
            Resources
            <ResourcesMenu />
          </span>
        </span>
        <Link to="/check_my_mood" className={styles.HeaderMenuNavLink}>Mood Quiz</Link>
      </div>

      <div className="ShowFor992BigScreenOnly">
        <div className={styles.HeaderButtons}>
          <a href="https://www.sparx.org.nz/contact" className={'PrimaryButton TransparentButton'}>Need help now?</a>
          {isLoggedIn ?
            <>
              <NavigateButton path="/profile" label="My Account" styleName={'PrimaryButton WhiteButton'} />
              <NavigateButton path="/login" onClickFunc={handleLogout} label="Log out" styleName={'PrimaryButton WhiteButton'} />
            </> : <NavigateButton path="/login" label="Login / Sign Up" styleName={'PrimaryButton WhiteButton'} />
          }
        </div>
      </div>
      <div className="ShowFor992SmallScreenOnly" style={{ width: '100%'}}>
        <div className={styles.HeaderButtons}>
          <a href="https://www.sparx.org.nz/contact" className={`PrimaryButton WhiteButton ${styles.MobileButton}`}>Need help now?</a>
          {isLoggedIn ?
            <>
              <NavigateButton path="/profile" label="My Account" styleName={`PrimaryButton ${styles.MobileButton}`} />
              <NavigateButton path="/login" onClickFunc={handleLogout} label="Log out" styleName={`PrimaryButton ${styles.MobileButton}`} />
            </> : <NavigateButton path="/login" label="Login / Sign Up" styleName={`PrimaryButton ${styles.MobileButton}`} />
          }
        </div>
      </div>

    </div>
  );
};

const Header: FC = () => {
  const [drawerMenuIsOpen, setDrawerMenuIsOpen] = useState(false);
  const toggleDrawer = () => setDrawerMenuIsOpen(!drawerMenuIsOpen);

  useEffect(() => {
    if (drawerMenuIsOpen) {
      document.body.classList.add('drawer-open');
    } else {
      document.body.classList.remove('drawer-open');
    }
  }, [drawerMenuIsOpen]);

  return (
    <div className={styles.Header} data-testid="Header">
      <section id="header">
        <div className={styles.SectionView}>
          {/* Logo and Hamburger */}
          <div>
            <div className={styles.HeaderTop}>
              <Link to="https://www.sparx.org.nz/">
                <img src={logo} className={styles.Logo} alt="logo" />
              </Link>
              <div className={`${styles.HeaderHamburger} ${drawerMenuIsOpen ? styles.HeaderHamburgerOpen : ''}`} onClick={toggleDrawer}>
                <div className={styles.HeaderHamburgerBar}></div>
                <div className={styles.HeaderHamburgerBar}></div>
              </div>
            </div>
          </div>

          {/* Menu */}
          <div className="ShowFor992BigScreenOnly" style={{ flexGrow: '1' }}>
            <NavBar />
          </div>
          <div className="ShowFor992SmallScreenOnly">
            <div className={`${styles.DrawerMenu} ${drawerMenuIsOpen ? styles.DrawerMenuOpen : ''}`}>
              <span onClick={() => setDrawerMenuIsOpen(false)}>
                <NavBar />
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Header;
